module.exports = __webpack_public_path__ + "img/icon_no_order.79b0c1b8.png";